import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const Title = styled.div`
  font-family: var(--app-font);
  font-weight: bold;
  font-size: 1.25rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

export const Subtitle = styled.div`
  font-family: var(--app-font);
  font-weight: normal;
  font-size: 1rem;
  padding-bottom: 2em;
  color: ${colors.GRAY_DARK};
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const warningIcon = {
  color: colors.GREEN,
  height: '3rem',
  width: '3rem',
};

export const acceptButton = {
  fontWeight: 'bold',
  fontFamily: 'var(--app-font)',
  backgroundColor: colors.GREEN,
};

export const cancelButton = {
  fontWeight: 'bold',
  fontFamily: 'var(--app-font)',
  backgroundColor: colors.WHITE,
  color: colors.BLACK,
  '&:hover': {
    backgroundColor: colors.RED,
  },
};
